<script setup>
// Surfaces a waiting service-worker update. Applying it reloads onto the new
// bundle, where boot runs any new migrations in order before the app returns.
import Icon from './ui/Icon.vue'
import { updateState, applyUpdate } from '../pwa'
import { t } from '../stores/i18n'

const busy = () => {} // reload takes over; no local state needed
</script>

<template>
  <Transition name="drop">
    <div
      v-if="updateState.available"
      class="flex items-center gap-3 border-b border-accent/30 bg-accent-soft px-4 py-2.5"
      role="status"
    >
      <Icon name="download" :size="17" class="shrink-0 text-accent" />
      <p class="min-w-0 flex-1 text-[13px] leading-snug">
        <span class="font-semibold">{{ t('update.ready') }}</span>
        <span class="text-muted"> {{ t('update.detail') }}</span>
      </p>
      <button class="btn-primary shrink-0 !py-1.5 !text-[13px]" @click="applyUpdate">{{ t('update.now') }}</button>
    </div>
  </Transition>
</template>

<style scoped>
.drop-enter-active,
.drop-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.drop-enter-from,
.drop-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
